module.exports = __webpack_public_path__ + "media/images/lb/856-5794f6f0e2dd29b5fc2eedfc279a3cd1.svg";